import { getNotificationKey } from './notificationTargets';

export const initialNotificationState = {
  received: [],
  dismissedKeys: [],
  pendingKeys: [],
};

export const notificationCenterReducer = (state, action) => {
  if (action.type === 'received') {
    return {
      ...state,
      received: Array.isArray(action.items) ? [...action.items] : [],
    };
  }

  if (action.type === 'dismiss_started' || action.type === 'dismissed') {
    const key = action.key ?? getNotificationKey(action.item);
    if (!key || state.dismissedKeys.includes(key)) return state;
    return {
      ...state,
      dismissedKeys: [...state.dismissedKeys, key],
      pendingKeys: [...state.pendingKeys, key],
    };
  }

  if (action.type === 'dismiss_succeeded') {
    return {
      ...state,
      pendingKeys: state.pendingKeys.filter((key) => key !== action.key),
    };
  }

  if (action.type === 'dismiss_failed') {
    return {
      ...state,
      dismissedKeys: state.dismissedKeys.filter((key) => key !== action.key),
      pendingKeys: state.pendingKeys.filter((key) => key !== action.key),
    };
  }

  if (action.type === 'reset') {
    return { ...initialNotificationState };
  }

  return state;
};

export const createNotificationDismissalController = ({ persist, dispatch, onError }) => {
  const inFlightKeys = new Set();

  return async (item) => {
    const key = getNotificationKey(item);
    if (!key || inFlightKeys.has(key)) return false;

    inFlightKeys.add(key);
    dispatch({ type: 'dismiss_started', item, key });
    try {
      await persist(key);
      dispatch({ type: 'dismiss_succeeded', key });
      return true;
    } catch (error) {
      dispatch({ type: 'dismiss_failed', key });
      onError?.(error);
      return false;
    } finally {
      inFlightKeys.delete(key);
    }
  };
};

export const getEffectiveNotifications = (state) => {
  const dismissed = new Set(state.dismissedKeys);
  const seen = new Set();
  return state.received.filter((item) => {
    const key = getNotificationKey(item);
    if (!key || dismissed.has(key) || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
